// Setting to false by default: Small coordinate/radius adjustments on-site
// must NOT invalidate physical printed paper QR codes.
// Validation is strictly handled server-side via worker's live GPS.
export const ENABLE_QR_OUTDATED_CHECK = false;

// Keep manual replacement available in code without exposing the rare action in Setup.
export const ENABLE_MANUAL_QR_REGENERATION = false;
